import Aurelia, { ConsoleSink, LoggerConfiguration, LogLevel } from "aurelia";
import { DialogDefaultConfiguration } from "@aurelia/dialog";
import { I18nConfiguration } from "@aurelia/i18n";
import { RouterConfiguration } from "@aurelia/router";
import { StandardConfiguration, SVGAnalyzer } from "@aurelia/runtime-html";
import { StateDefaultConfiguration } from "@aurelia/state";
import { DefaultVirtualizationConfiguration } from "@aurelia/ui-virtualization";
import { ValidationHtmlConfiguration } from "@aurelia/validation-html";

import { SciChartSurface } from "scichart";

import { AuthHook } from "@/hooks/AuthHook";
import { AppMain } from "@/routes/main/app-main";
import { initialStateCreator } from "@/store/state";

import "toastify-js/src/toastify.css";
import "gridstack/dist/gridstack.min.css";
import "./styles/global.scss";
import "./styles/tw-config.css";
import "@mdi/font/css/materialdesignicons.css";

import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";

// OB components
import "@oicl/openbridge-webcomponents/dist/automation/automation-tank/automation-tank";
import "@oicl/openbridge-webcomponents/dist/components/icon-button/icon-button.js";
import "@oicl/openbridge-webcomponents/dist/icons/icon-expand.js";
import "@oicl/openbridge-webcomponents/dist/navigation-instruments/azimuth-thruster/azimuth-thruster.js";
import "@oicl/openbridge-webcomponents/dist/navigation-instruments/instrument-field/instrument-field.js";
import "@oicl/openbridge-webcomponents/dist/navigation-instruments/rudder/rudder.js";
import "@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/thruster.js";

import { CoerceFormatValueConverter } from "./converters/coerce-format";
import { PercentageFormatValueConverter } from "./converters/percentage-format";
import { persistentStatePlugin } from "./store/persistent-store";
import { stateReducer, updateDevtools } from "./store/reducer";
// Translation files
import * as en from "./translations/en.json";
import * as pt_br from "./translations/pt_br.json";

SciChartSurface.setRuntimeLicenseKey(import.meta.env.VITE_SCI_LICENSE);

const LOCAL_STATE_KEY = "local-state";
const keysToExclude = ["followedAlarms", "alarms"];

// this now needs to set outside the main Aurelia.register method because it's already registered by default
StandardConfiguration.customize((config) => {
  config.coercingOptions.enableCoercion = true;
  config.coercingOptions.coerceNullish = true;
});

Aurelia.register(
  StateDefaultConfiguration.init(
    initialStateCreator(LOCAL_STATE_KEY),
    stateReducer,
    updateDevtools
  ),

  SVGAnalyzer,

  persistentStatePlugin(LOCAL_STATE_KEY, keysToExclude),

  ValidationHtmlConfiguration,

  LoggerConfiguration.create({
    level: LogLevel.debug,
    sinks: [ConsoleSink],
  }),

  RouterConfiguration.customize({
    title: "${componentTitles}${appTitleSeparator}C-Connect",
    useUrlFragmentHash: false,
  }),

  AuthHook,

  I18nConfiguration.customize((options) => {
    options.translationAttributeAliases = ["i18n"];
    options.initOptions = {
      resources: {
        en: { translation: en },
        pt_br: { translation: pt_br },
      },
    };
  }),

  DialogDefaultConfiguration.customize((dialogSetting) => {
    dialogSetting.lock = false;
  }),

  DefaultVirtualizationConfiguration,
  // Common components
  // # For some reason au-compose is not working with template level imports
  // # So we need to import the converters here. I will open an issue about it
  CoerceFormatValueConverter,
  PercentageFormatValueConverter
)
  .app(AppMain)
  .start();
